import {
    PatientApi,
    CoreFetch,
    ListProviderCollectionPaymentsRequest,
    ProviderPatient, ProviderCollectionPayment, CollectionApi, ListProviderPatientsRequest, ProviderPatientStatement,
} from '@enter/core';
import { IItemListing } from './root.store';
import { fetch, parseResponse } from './util';

export class PatientService {

    // public async fetchPatientListing(
    //     lpgr: ListProviderPatientsRequest,
    // ): Promise<IItemListing<ProviderPatient> | undefined> {
    //     const res = await fetch(lpgr, req =>
    //         CoreFetch<PatientApi>(PatientApi).listProviderPatientsRaw(req),
    //     );
    //     if (res) {
    //         return {
    //             items: await parseResponse(res),
    //             limit: Number(await res.raw.headers.get('pagination-limit')),
    //             offset: Number(await res.raw.headers.get('pagination-offset')),
    //             total: Number(await res.raw.headers.get('pagination-total')),
    //         };
    //     }
    // }

    public async fetchPatientStatement(
        patientId: string
    ): Promise<ProviderPatientStatement> {
        const res = await CoreFetch<PatientApi>(PatientApi).getProviderPatientStatement(
            {id: patientId}
        );
        return res;
    }

}